import React from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import PasswordField from '../../components/elements/form/PasswordField'
import { useState } from 'react'
import { ERROR, SET_SUCCESS } from '../../store/types'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import FormButton from '../../components/elements/form/FormButton'

const CreateNewPassword = () => {
    const dispatch = useDispatch()
    const [validationErrors, setValidationErrors] = useState({})  
    const [password, setPassword] = useState('');
    const navigate = useNavigate()
    const { resetCode } = useParams()

    const validateForm = () => {
        let errors = {}

        if(!password || password === '') {
            errors.password = true
        }
        setValidationErrors(errors)

        return errors
    }

    const [processing, setProcessing] = useState(false);
    const createPassword = async  () => {
        const headers = {
            'Content-Type': 'application/json'
        }
        
        if (Object.values(validateForm()).includes(true)) {

            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }

        setProcessing(true)

        const requestPayload = { 
            password, resetCode
        }
        try {
            await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/password-reset`, requestPayload, { headers })  
            
            dispatch({
                type: SET_SUCCESS,
                payload: 'New password created successfully. Redirecting to login...'
            })
            setTimeout(() => {
                navigate('/')
            }, 3000);
                      

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setProcessing(false)
        }
    }

    return (
        <div>
            <div className="relative flex flex-row items-center justify-center w-full bg-vcm-light-purple bg-opacity-5 min-h-screen h-inherit">
                <div className="w-11/12 lg:w-6/12 xl:w-4/12 p-4 lg:p-8 2xl:p-12 rounded-[8px] bg-white">
                    <h1 className="text-xl font-thin text-primary mb-5 text-opacity-80 tracking-[0.2em] uppercase">vaatia college makurdi</h1>

                    <p className="">Create a new password</p>

                    <div className='w-full mt-2'>
                        <p className='text-gray-600 text-sm'>Don't have an account yet? <Link className='text-blue-500 font-[500]' to='signup'>Set up your account here</Link></p>
                    </div>

                    
                    <div className='mt-4'>
                        <PasswordField
                            inputLabel="Password" 
                            fieldId="password" 
                            inputType="password" 
                            preloadValue={''}
                            hasError={validationErrors && validationErrors.password} 
                            returnFieldValue={(value)=>{setPassword(value)}}
                            showPasswordMeter={true}
                        />
                    </div>

                    <p className="my-3 text-sm text-opacity-70 block">Already done with this? <Link to="/" className="text-blue-600">Proceed to login</Link></p>
                    
                    <div className='mt-8'>
                        <FormButton buttonLabel="Create your password" buttonAction={()=>{createPassword()}} processing={processing} />
                    </div>

                </div>    
            </div>
        </div>
    )
}

export default CreateNewPassword